export const predialOrScripturesTypes = [
  {
    value: "predial",
    label: "Predial",
    description: "Predial del año en curso",
  },
  {
    value: "scriptures",
    label: "Escrituras",
    description: "Documento notarial del inmueble",
  },
];

export const labelPredialOrScripturesOptions: Record<string, string> = {
  predial: "Predial",
  scriptures: "Escrituras",
};
